<template>
  <!--  eslint-disable max-len  -->
  <section id="Terms">
    <div class="row">
      <div class="title col-md-8 d-flex align-items-center justify-content-start ml-auto">
        <h1 class="h5">HS超集點申請書</h1>
      </div>
      <div class="col-12">
        <div class="desc mt-30 p-50">
          <h6 class="mb-10">※個人資料蒐集、處理及利用告知事項（含隱私權聲明）及服務條款※</h6>
          <p
            class="mb-20"
          >申請人應詳細閱讀下列「個人資料蒐集聲明及服務條款」(以下簡稱本條款)，申請人完成申請手續或開始使用HS超集點所提供之會員服務時，即視為已知悉且完全同意本條款之約定，並完全接受現有與未來衍生之會員服務項目。若申請人係未滿二十歲，應於申請人之法定代理人閱讀、瞭解並同意本條款之內容及其後修改之變更後，方得使用或繼續使用。當申請人使用或繼續使用HS超集點時，即表示申請人之法定代理人已閱讀、瞭解並同意接受以下本條款之內容及其後修改變更。</p>
          <ol class="first">
            <li>申請人須於HS超集點【申請書】或自行下載漢齊科技股份有限公司(以下簡稱本公司)發行之HS超集點APP填寫基本個人資料向本公司提出申請，經本公司完成相關實體卡或虛擬卡發卡作業後成為HS超集點之會員（以下簡稱會員）並取得本卡。</li>
            <li>
              本公司依據個人資料保護法第八條第一項規定及為保障個人資料當事人之權利，謹向申請人告知下列事項：
              <ol class="second">
                <li>蒐集之目的為提昇服務品質及加強個人化服務，本公司個人資料蒐集的目的在於行銷業務、消費者及客戶管理與服務、網路購物及其他電子商務服務及調查、發送電子報、本公司最新資訊、統計與研究分析、售後服務、履行法定或合約義務、保護當事人及相關利害關係人之權益、以及經營合於營業登記項目或組織章程所定之業務等目的。</li>
                <li>蒐集之個人資料類別 申請人提供於本公司之申請書及其他文件之各項個人資料，包括姓名、電話、地址、生日等基本資料及會員之消費時間、消費明細、店點、發票號碼、卡號、HS超集點點數、網頁瀏覽紀錄、位址資訊、其他社會活動等生活消費相關資料、或其他得以直接或間接識別申請人個人之資料。</li>
                <li>
                  個人資料利用之期間、地區、對象及方式
                  <ol class="third">
                    <li>期間：本公司營運期間，或個人資料蒐集之特定目的存續期間/依相關法令規定或契約約定之保存年限。</li>
                    <li>地區：中華民國領域內、利用對象之國內外所在地及本公司海外關係企業所在地之地區。</li>
                    <li>利用對象： 本公司、本公司之分公司、與本公司有從屬關係之子公司或有控制關係之母公司暨其分公司或集團關係之公司、或與本公司或前述公司因業務需要訂有契約關係者（如、特約商、物流、郵寄廠商）。</li>
                    <li>
                      利用方式：
                      <ol class="forth">
                        <li>會員提供之辨識個人資料(如：電子郵件住址、電話號碼等)，將使用於辨別會員之身分並提供會員基本服務。</li>
                        <li>於寄送商品時，會員個人資料將被提供予給相關物流、郵寄廠商，俾以完成寄送。</li>
                        <li>本公司將利用會員之地址及電子郵件、電話號碼進行宣傳行銷由本公司及本公司之關係企業、特約商與合作夥伴提供之產品與服務。</li>
                        <li>於寄送商品時，會員個人資料將被提供予給相關物流、郵寄廠商，俾以完成寄送。</li>
                        <li>為提供服務所為之市場統計調查與分析。</li>
                        <li>以自動化機器或其他非自動化之利用方式。</li>
                      </ol>
                    </li>
                  </ol>
                </li>
                <li>
                  依據個人資料保護法第三條規定，會員就相關個人資料得向本公司行使下列權利：
                  <ol class="third">
                    <li>除個人資料保護法第十條但書所列舉之情形外，會員得查詢、請求閱覽或請求製給複製本，而本公司依法得酌收必要成本費用。</li>
                    <li>請求補充或更正個人資料，惟依法會員應提供相當之資料以為釋明。</li>
                    <li>請求停止蒐集、處理或利用及請求刪除個人資料，惟依法本公司因執行業務所必需者，不在此限。</li>
                  </ol>
                </li>
                <li>為確保個人權益，申請人應填寫本人正確資料，若有變動並請盡速更新，藉以維持系統紀錄資料之正確性。申請人需出示或提供相關身分證件以供驗證且不得冒用他人身分進行申請，否則應自負相關民刑事法律責任。申請人得自由選擇是否提供相關個人資料，惟若申請人拒絕提供相關個人資料或提供之資料不足、有誤時，本公司除將無法進行必要之審核、處理或無法提供完整之服務外，亦可能無法成為本卡會員，倘已核卡將逕行停卡處理，申請人不得主張任何權利。</li>
                <li>真實登錄之義務 申請人於註冊申請時即代表已完全知悉並充分瞭解身為「HS超集點」會員系統的使用者應自行申請帳號，並於註冊時提供完整、詳實及正確的個人資料（包括但不限於真實姓名及電話號碼等），且應即時更新過時或已經變更之個人資料。倘您提供的個人資料有任何錯誤、虛偽不實、過時或不完整，經本司查證並告知後申請人仍未依相關流程自行變更個人資料時，本公司得逕行暫停或取消您的「HS超集點」會員資格、使用本公司各項服務之權利以及帳號內未使用的點數及優惠券。此外，若您以虛假、錯誤或不正當之方式在「HS超集點」會員系統內進行各項累兌之消費行為，本公司得逕行暫停或取消您的「HS超集點」會員資格及使用本公司所提供各項服務之一切權利。申請人不得主張上述暫停或失效期間之任何權利。</li>
                <li>帳號保管之義務 申請人註冊成為「HS超集點」會員後，將會得到一組會員帳號及密碼。申請人已充分瞭解帳號一旦設定，就不可再變更。申請人必須就該帳號及密碼之保管和利用該帳號及密碼所進行的一切行動負完全責任。申請人同意不會將帳號、密碼讓與或出借他人使用，若申請人發現該密碼或帳號遭他人非法使用或有任何異常破壞使用安全的情形時，應立即通知本公司；若可歸責於申請人之保管疏忽，導致申請人之「HS超集點」會員帳號或密碼遭他人非法使用，及因此所衍生之任何損失或損害，申請人應自負其責。</li>
              </ol>
            </li>
            <li>本公司得將申請人之個人資料提供予本公司關係企業、特約商或各合作夥伴，作為其於上開特定目的內辦理包括但不限於點數餘額通知、統計調查分析、交叉比對、行銷與其他服務使用，惟本公司將僅於必要範圍內提供資料，且將對申請人資料為適當之保護。若申請人表示不同意或要求該關係企業、特約商或合作對象停止對其提供會員服務時，該關係企業、特約商或合作對象將立即停止，而申請人之權益不會受到影響。</li>
            <li>
              關於申請人註冊以及其他特定資料，將依法受到保護與規範。在下列之情況下，本公司有可能會提供申請人之個人資料給司法警政機關或主張其權利受侵害並提出司法機關正式證明之第三人：
              <ol class="second">
                <li>基於法律之規定或受司法機關與其他有權機關基於法定程序之要求。</li>
                <li>申請人使用會員服務之行為違反相關服務規範。</li>
                <li>惟申請人同意本公司得為推薦產品、提供服務及贈獎之目的時，提供必要之申請人資料給其他合作對象(第三者)做必要範圍內之妥善運用；若申請人不同意將其資料列於其他合作對象(第三者)產品或服務名單內，可以通知本公司於名單中刪除其資料，並視同放棄其優惠或獲獎權利。</li>
              </ol>
            </li>
            <li>申請人使用會員服務時，其使用過程中所有的資料記錄，以會員服務資料庫所記錄之資料為準，如有任何糾紛，以會員服務資料庫所記錄之電子資料為認定標準。</li>
            <li>當申請人參與本公司線上活動、網路調查或其他相關服務時，因服務性質的不同，本公司可能要求提供姓名、身分證字號、住址、電話、電子信箱或其他相關必要資料。除此之外，本公司亦可能保留申請人於上網瀏覽或查詢時，伺服器自行產生之相關記錄，包括但不限於使用連線設備之IP位址、使用之瀏覽器、使用時間、瀏覽及點選資料紀錄等。使用人使用本公司官方網站連結之其他網站，亦可能蒐集您個人之資料，對於您主動提供其他網站之個人資料，將依相關法令及各該連結網站所揭露之隱私權保護政策蒐集、處理與利用，不適用本服務條款，本公司亦不負其責。</li>
            <li>為保護申請人個人資料之隱密及完整性，本公司謹恪遵政府相關法令及資訊管理原則。申請人之個人資料會被嚴密保存於本公司或本公司所委託具有高度安全性、穩定性之資訊保管公司之資料儲存系統中；要取得申請人之任何資料，都必須於本公司訂定之資料授權範圍內，始可進行資料之取得與使用。此外，本公司已採用適當技術及組織安全措施，保障申請人之個人資料免遭遺失或任何非法處理。本公司不會將申請人之資料提供給本公司或本服務條款所告知以外之任何人，惟經申請人之同意、司法單位或其他主管機關依法並透過正式且合法之程序要求時，則不在此限。</li>
            <li>
              本公司以目前一般認為合理之方式及技術，維護會員服務之正常運作。但於下列情況之下，本公司將暫停或中斷會員服務之全部或一部：
              <ol class="second">
                <li>對會員服務相關軟硬體設備進行搬遷、更換、升級、保養或維修時。</li>
                <li>會員有任何違反政府法令或本條款情形。</li>
                <li>天災或其他不可抗力之因素所導致之會員服務停止或中斷。</li>
                <li>其他不可歸責於本公司之事由所致之會員服務停止或中斷。</li>
                <li>非本公司所得控制之事由而致會員服務資訊顯示不正確、或遭偽造、竄改、刪除或擷取、或致系統中斷或不能正常運作時。</li>
              </ol>
            </li>
            <li>若申請人決定終止本公司會員資格，可直接由本公司所提供之機制進行取消，本公司將儘快註銷申請人的會員資料。經申請人通知本公司取消會員資格後(並提供身分證影本以供本公司查核)，並自停止本公司會員身分之日起（以本公司電子郵件或簡訊或其他管道發出日期為準），喪失所有會員服務所提供之優惠及權益。</li>
            <li>本公司具有更改各項會員服務內容或終止任一違反法律規定之會員服務之權利。本公司為因應社會環境變化、業務需求、科技技術之進步及法令規定之變更，將不定時修訂與公布本服務條款。若有變更時，會將相關修訂事項逕於本公司HS超集點官方網站及HS超集點APP公告，請隨時參閱，以保障您的權益。</li>
            <li>本條款中，任何條款之全部或一部無效時，不影響其他約定之效力。</li>
            <li>申請人與本公司之權利義務關係，應依中華民國相關法令規範、主管機關之解釋等為處理依據。本公司之任何聲明、條款如有未盡完善之處，將依誠實信用原則及其他應適用之相關規定解決。若產生任何爭議，以臺灣台北地方法院為第一審管轄法院。</li>
            <li>申請人若對本公司蒐集、處理、利用及/或國際傳輸個人資料之管理方針及申請人所享有之權利或服務有任何疑問，歡迎透過HS超集點APP揭露之通訊方式來信致電洽詢。</li>
          </ol>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Terms',
  metaInfo: {
    title: '使用者條例 | ',
  },
};
</script>
<style lang="scss" scoped>
#Terms {
  overflow: hidden;
  padding: 20px 0 100px;
  p,
  li {
    letter-spacing: 1.5px;
  }
  .title {
    border-bottom: 2px solid $primary-light;
  }
  .desc {
    background: linear-gradient(to right, white 30%, $secondary-white 120%);
    p {
      color: $secondary;
    }
    ol {
      &.first {
        list-style-type: disc;
        > li {
          margin-bottom: 10px;
        }
        .second {
          margin-top: 10px;
          > li {
            margin-bottom: 10px;
          }
          .third {
            list-style-type: upper-alpha;
            margin-top: 10px;
            > li {
              margin-bottom: 10px;
            }
            .forth {
              list-style-type: lower-alpha;
              margin-top: 10px;
              > li {
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
